import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import * as userActions from "redux/actions/userActions";

import { Security } from "@okta/okta-react";
import { OktaAuth, TokenManager, toRelativeUrl } from "@okta/okta-auth-js";

import jwt from "jwt-decode";
import { appInsights } from 'shared/utils/helperFunctions/appInsights';

// const OKTA_DOMAIN =
//   window.oktaConfig && window.oktaConfig.domain
//     ? window.oktaConfig.domain
//     : process.env.REACT_APP_OKTA_DOMAIN;

const CLIENT_ID =
  window.oktaConfig && window.oktaConfig.client_id
    ? window.oktaConfig.client_id
    : process.env.REACT_APP_CLIENT_ID;

const ISSUER =
  window.oktaConfig && window.oktaConfig.issuer
    ? window.oktaConfig.issuer
    : process.env.REACT_APP_OKTA_ISSUER;

const CALLBACK_PATH =
  window.oktaConfig && window.oktaConfig.redirect_uri
    ? window.oktaConfig.redirect_uri
    : process.env.REACT_APP_CALLBACK_PATH;

// const CALLBACK_PATH = process.env.REACT_APP_CALLBACK_PATH;

const HOST = window.location.host;

let CALLBACK_PROTOCOL = process.env.REACT_APP_CALLBACK_PROTOCOL || "https";

if (HOST === "localhost:3000") CALLBACK_PROTOCOL = "http";

const REDIRECT_URI = `${CALLBACK_PROTOCOL}://${HOST}${CALLBACK_PATH}`;

const SCOPES = "openid profile email";

const oktaConfig = {
  issuer: ISSUER,
  clientId: CLIENT_ID,
  redirectUri: REDIRECT_URI,
  scopes: SCOPES.split(/\s+/),
};

console.log("oktaConfig", oktaConfig);

const oktaAuth = new OktaAuth(oktaConfig);

const OktaSecurity = (props) => {
  const userDetails = useSelector((state) => state.currentUser.details);
  const dispatch = useDispatch();
  const { store } = props;
  const { getUser } = userActions;
  const history = useHistory();

  window.accessCheck = { auth: oktaAuth, history };

  console.log("window.accessCheck", window.accessCheck);

  useEffect(() => {
    if (store) {
      store.subscribe(() => {
        // this.setAdmin(store);
      });
    }
  }, [store]);

  useEffect(() => {
    console.log("auth", oktaAuth, "config", oktaConfig);
    getUserDetails();
  }, [oktaAuth]);

  useEffect(() => {
    if (userDetails){
      localStorage.setItem("userInfo", JSON.stringify(userDetails));
      appInsights.trackTrace({
        message: JSON.stringify(userDetails),
        severityLevel: 1 // Information
    });
    }
    else localStorage.removeItem("userInfo");
  }, [userDetails]);

  const getUserDetails = () => {
    const accessToken = oktaAuth.getAccessToken();
    console.log("access token", accessToken);
    localStorage.setItem("oktaAccessToken", accessToken);

    if (accessToken) {
      var user = jwt(accessToken);

      console.log("user", user);

      dispatch(getUser(user.sub?.toLowerCase()))
        .then((response) => {
          if (response && response.payload) {
            if (response.payload.status !== 200) {
              history.push("/unauthorized");
            }
          }
        })
        .catch((error) => {
          console.log("Error getting user", error);
          localStorage.removeItem("oktaAccessToken");
          if (error.response) {
            // enqueueSnackbar(`Error getting user info ${error.response.data}`, {
            //   variant: "error",
            // });
          } else {
            // enqueueSnackbar(`Error getting user info ${error}`, {
            //   variant: "error",
            // });
          }
        });
    }
  };

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    history.push(toRelativeUrl(originalUri || "/", window.location.origin));
    window.location.reload();
  };
  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      {props.children}
    </Security>
  );
};

export default OktaSecurity;
